import React from 'react';
import { satsumaimoImage } from '../../data/presellContent';
export function Discovery() {
  return <section id="discovery" className="w-full bg-white" data-id="element-5" data-mp="1xcj909dciv13">
      <div className="max-w-6xl mx-auto px-5 md:px-8 py-14 md:py-20" data-id="element-6" data-mp="1xf5g67wbr8is">
        <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-center" data-id="element-7" data-mp="1tbqylcsqmk38">
          <figure data-id="element-8" data-mp="1od5yrehee2fb">
            <img src={satsumaimoImage} alt="Freshly harvested Japanese purple satsumaimo sweet potatoes" className="w-full h-[240px] sm:h-[320px] md:h-[380px] object-cover rounded-2xl" loading="lazy" data-id="element-9" data-mp="1odp47vpv2ycg" />
            <figcaption className="mt-3 text-sm text-[#8A9A8F]" data-id="element-10" data-mp="2c9a0lwgs32g5">
              Satsumaimo, the purple sweet potato grown and eaten in the village.
            </figcaption>
          </figure>

          <div data-id="element-11" data-mp="34qw56rvzp2s4">
            <h2 className="text-2xl md:text-4xl font-bold text-[#22322C] leading-snug" data-id="element-12" data-mp="34rfly59wll4k">
              It May Not Be Just "Wear And Tear"
            </h2>

            <p className="mt-6 text-lg text-[#4A5D50] leading-relaxed" data-id="element-13" data-mp="2zxtaggfh7nac">
              As the body changes over time, joints may lose some of the natural
              fluid that helps cushion and lubricate movement. When that support
              starts to decline, stiffness, discomfort, and reduced mobility may
              become more noticeable.
            </p>

            <p className="mt-8 border-l-4 border-[#3F8C86] bg-[#F2F7F6] rounded-r-xl px-6 py-5 text-lg md:text-xl font-semibold text-[#22322C] leading-relaxed" data-id="element-14" data-mp="3i6yfekqiu48">
              That's why more attention is being given to supporting the body's
              natural joint lubrication.
            </p>
          </div>
        </div>
      </div>
    </section>;
}